<template>
  <nav>
    <div class="bar-main">
      <el-scrollbar>
        <div v-for="item in ShowItems" :key="item" :class="{ active: item.URL === curURL }" class="bar-item"
             @click="NavGoTo(item)">
          <div class="bar-item-icon">
            <svg-icon :class="item.Icon" :icon-class="item.Icon"/>
          </div>
          <div class="bar-item-name">{{ item.Abbr ? item.Abbr : item.Name }}</div>
        </div>
      </el-scrollbar>
    </div>

    <div v-if="props.ShowExtra" class="bar-extra">
      <div class="bar-item" data-active="false">
        <div class="bar-item-icon">
          <el-tooltip class="item" content="配置" placement="top">
            <svg-icon class="config" icon-class="config"/>
          </el-tooltip>
        </div>
      </div>
    </div>
  </nav>
</template>

<script lang="ts" setup>
import {useRoute, useRouter} from "vue-router";
import {computed, inject, onMounted, ref, watch} from "vue";
import {PBEntity} from "@mfksoft.ops/api";

const RootModules = inject("RootModules") as [PBEntity.Tree];
const SubModules = inject("SubModules") as [PBEntity.Tree];
const route = useRoute();
const router = useRouter();
const props = defineProps({
  /** 显示底部设置项目 */
  ShowExtra: Boolean,
});
/** 当前路径 */
const curURL = computed(() => {
  return route.path;
});

onMounted(() => {
  LoadModules()
})

// 获取子节点
const GetModuleList = (moduleCode: string) => {
  // 先遍历根节点
  for (const r of RootModules.value) {
    if (r.Module.Code == moduleCode || r.Module.ID == moduleCode) {
      return r.Children;
    }
  }

  for (const r of SubModules.value) {
    if (r.Module.Code == moduleCode) {
      return GetModuleList(r.Module.ParentID)
    }
  }
}
watch(
    () => RootModules.value,
    () => LoadModules()
);
watch(
    () => SubModules.value,
    () => LoadModules()
);

const LoadModules = () => {
  ShowItems.value.splice(0);
  const items = GetModuleList(route.name)
  items?.forEach((item: PBEntity.Tree) => {
    if (item.Module?.IsMenu)
      ShowItems.value.push({
        Name: item.Module.Name,
        Code: item.Module.Code,
        Icon: item.Module.Icon,
        URL: item.Path
      })
  })
}

const ShowItems = ref([] as any);
/** 导航跳转 */
const NavGoTo = (item: any) => {
  switch (item.Code) {
    default:
      router.push(item.URL);
      break;
  }
};
</script>

<style lang="scss" scoped>
nav {
  $leftWidth: 76px;
  height: calc(100% - 10px);
  width: $leftWidth;
  float: left;
  // padding: 0 6px 10px;
  padding-bottom: 10px;
  flex-direction: column;
  display: flex;
  box-shadow: inset -1px 0 0 0 rgba(142, 145, 147, 0.06);
  transition-duration: 0.15s;
  z-index: 90;
  background-color: rgba(242, 245, 247, 1);

  .bar-main {
    height: 100%;
    overflow-x: hidden;
    overflow-y: hidden;
    flex: 1 1;
    position: relative;
    background: linear-gradient(rgb(242, 245, 247) 30%, hsla(0, 0%, 100%, 0)), linear-gradient(hsla(0, 0%, 100%, 0), rgb(242, 245, 247) 70%) 0 100%, radial-gradient(farthest-side at 50% 0, rgba(0, 0, 0, .2), transparent), radial-gradient(farthest-side at 50% 100%, rgba(0, 0, 0, .2), transparent) 0 100%;
    background-repeat: no-repeat;
    background-size: 100% 40px, 100% 40px, 100% 14px, 100% 14px;
    background-attachment: local, local, scroll, scroll;
    // padding-top: 10px;
    :deep(.el-scrollbar__wrap) {
      background: none;
    }

    .bar-item:first-child {
      padding-top: 20px;
    }

    .bar-item:last-child {
      margin-bottom: 20px;
    }
  }

  .bar-extra {
    border-top: 1px solid #e8e8e8;
    padding-top: 7px;
    box-sizing: border-box;
    overflow-x: hidden;
  }

  .bar-item {
    width: 100%;
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 12px 0;

    &-icon {
      height: 28px;
      line-height: 28px;
      color: #adadad;

      svg {
        font-size: 25px;
      }
    }

    &-name {
      line-height: 18px;
      font-size: 12px;
      color: #6e6e6e;
    }
  }

  .bar-item:hover {
    .bar-item-icon,
    .bar-item-name {
      color: $ThemeColor;
    }
  }

  .bar-item.active {
    background-color: #ffffff;
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);

    .bar-item-icon {
      color: #007bee;
    }

    .bar-item-name {
      color: #007bee;
    }
  }

  .skeleton-bar-item-icon {
    width: 28px;
    height: 58px;
  }

  .skeleton-bar-item-p {
    width: 100%;
  }

  // .bar-item + .bar-item {
  //   padding-top: 25px;
  // }
}
</style>